<template>
  <v-navigation-drawer
    app
    right
    width="290"
    v-if="!isTV && !isFullscreen"
    v-model="drawerInput"
  >
    <v-toolbar flat>
      <v-toolbar-title>
        Configure
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleConfigDrawer">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <perfect-scrollbar style="height: calc(100% - 64px)">
      <v-card-text>
          <theme />
          <cell-wise-filter class="mb-4" />
          <!-- <v-select
            v-model="machineInput"
            :items="availableMachines"
            item-text="machinename"
            item-value="machinename"
            label="Select Machine"
            outlined
            dense
            clearable
            class="mb-4"
            :disabled="!selectedCell || availableMachines.length === 0"
          ></v-select> -->

          <v-row class="pt-12">
            <v-col>
              <file-upload
                className="pt-6 pb-6 pl-8 pr-8"
                :cell-name="selectedCell"
              />
            </v-col>
            <v-col>
              <v-btn
                small
                color="success"
                class="text-none pt-6 pb-6 pl-8 pr-8"
                @click="goToPreview"
              >
                <v-icon small left>mdi-eye-outline</v-icon>
                Preview
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import CellWiseFilter from './config/filters/CellWiseFilter.vue';
import FileUplode from './config/filters/FileUpload .vue';
import Theme from './config/Theme.vue';

export default {
  name: 'ConfigDrawer',
  components: {
    Theme,
    CellWiseFilter,
    'file-upload': FileUplode,
  },
  computed: {
    ...mapState('helper', ['configDrawer', 'isFullscreen']),
    ...mapGetters('helper', ['isTV']),

    selectedCell() {
      return this.$route.query.selectedcell || this.$route.query.cellname;
    },

    drawerInput: {
      get() { return this.configDrawer; },
      set(val) { this.setConfigDrawer(val); },
    },
  },
  mounted() {
    this.$nextTick(() => this.setConfigDrawer(false));
  },
  methods: {
    ...mapMutations('helper', ['setConfigDrawer', 'toggleConfigDrawer']),

    goToPreview() {
      this.$router.push({
        name: 'preview',
        query: {
          cellname: this.selectedCell,
          theme: this.$route.query.theme,
        },
      });
    },
  },
};
</script>
